import React from 'react';
import classNames from 'classnames';
import { Alert } from 'react-bootstrap';

const AlertMessage = ({ show = true, type = 'info', size = 'small', onDismiss = null, children }) => {
  const bsStyle = classNames({
    'success': type === 'success',
    'danger': type === 'error',
    'info': type === 'info'
  });
  const classes = classNames({
    'hide': !show
  });

  return (
   <Alert bsStyle={bsStyle} bsSize={size} className={classes} onDismiss={onDismiss}>
     { children }
   </Alert>
  );
};

export default AlertMessage;



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/AlertMessage.jsx